import { t } from "@/i18n-js/instance";
import { useCheckoutTabContext } from "./../CheckoutTabContext";
import { localeRoot } from "./../constants";
import { PROPERTIES } from "./../constants";
import { CoverImageField } from "./Properties/Fields/CoverImageField";
import { Container } from "./components/Container";
import { ItemClickable } from "./components/ItemClickable";
import { List } from "./components/List";

export const DefaultProperties = () => {
  const { goToSidebar } = useCheckoutTabContext();

  return (
    <Container>
      <List
        title={t([localeRoot, "builder.default.cover_image.title"])}
        tooltipText={t([localeRoot, "builder.default.cover_image.tooltip"])}
      >
        <CoverImageField />
      </List>
      <List title={t([localeRoot, "builder.default.product_details_title"])}>
        <ItemClickable
          title={t([localeRoot, "builder.badges.title"])}
          onClick={() => goToSidebar(PROPERTIES.BADGES)}
        />
        <ItemClickable
          title={t([localeRoot, "builder.benefits.title"])}
          onClick={() => goToSidebar(PROPERTIES.BENEFITS)}
        />
        <ItemClickable
          title={t([localeRoot, "builder.testimonials.title"])}
          onClick={() => goToSidebar(PROPERTIES.TESTIMONIALS)}
        />
      </List>
      <List title={t([localeRoot, "builder.default.price_features_title"])}>
        <ItemClickable
          title={t([localeRoot, "builder.countdown.title_sidebar"])}
          onClick={() => goToSidebar(PROPERTIES.COUNTDOWN)}
        />
        <ItemClickable
          title={t([localeRoot, "builder.price_callouts.title_sidebar"])}
          onClick={() => goToSidebar(PROPERTIES.PRICE_CALLOUTS)}
        />
      </List>
    </Container>
  );
};
